<template>
  <v-card
    :class="`${inDarkMode ? '' : 'white nearblack--text'} elevation-0`"
    min-width="300px"
    max-width="450px"
    width="100%"
  >
    <v-col>
      <v-row
        :class="`${inDarkMode ? 'darkblue' : 'primary'} white--text font-weight-medium align-center pa-3`"
      >
        <v-col>
          <span class="px-1 header-2 font-weight-bold cursor-pointer">
            Release Brief
          </span>
        </v-col>

        <v-spacer />

        <!-- <v-col
          class="cursor-pointer text-right"
        >
          <v-icon
            class="white--text"
            @click="goToDocs"
          >
            open_in_new
          </v-icon>
        </v-col> -->
      </v-row>

      <v-row
        class="pa-6"
      >
        <v-col>
          <!-- <v-row class="body-2 mb-6">
            <span>
              iAdOps is committed to providing a secure and reliable platform for our users. Below are
              some of the latest security updates implemented to enhance the security of your account and data.
            </span>
          </v-row> -->

          <v-row class="pt-3">
            <v-col>
              <v-row class="font-weight-bold body-2">
                Authentication Reliability Update
              </v-row>

              <v-row :class="`${inDarkMode ? '' : 'nearblack--text'} caption font-weight-medium pt-1`">
                <p>
                  We deployed an authentication resilience update to improve sign-in stability
                  in production.
                </p>

                <p>
                  The App Check and reCAPTCHA Enterprise configuration has been hardened to reduce
                  sign-in disruption risk caused by key mismatches or temporary configuration
                  issues.
                </p>
              </v-row>

              <v-row class="font-weight-bold body-2">
                Need Help?
              </v-row>

              <v-row :class="`${inDarkMode ? '' : 'nearblack--text'} caption font-weight-medium pt-1`">
                <p>
                  If you experience issues, contact <a
                    class="font-weight-bold"
                    href="mailto:tech@adops.com"
                  >tech@adops.com</a>
                  and include browser, timestamp, and the impacted account email.
                </p>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </v-card>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

const { mapGetters: mapAuthGetters, mapState } = createNamespacedHelpers('auth')

export default {
  name: 'WelcomeCard',
  data() {
    return {
      dismissed: null,
    }
  },
  computed: {
    ...mapAuthGetters([
      'alert',
      'isInternalUser',
      'inDarkMode',
    ]),
    ...mapState({
      user: (state) => state.user,
    }),
  },
  methods: {
    goToDocs() {
      this.$router.push('/docs/releases')
      this.dismissFeaturePrompt()
    },
    async dismissFeaturePrompt() {
      this.dismissed = true

      const { user } = this
      const { email, personEmail, settings = {} } = user
      const alert = { dismissed: true }
      const doc = { settings: { ...settings, alert } }
      const docId = email || personEmail
      const data = { doc, docId }

      return this.$store.dispatch('auth/updateUserSettings', data)
    },
  },
}
</script>
